__turbopack_context__.v({
  "answer": "_1lnL9W_answer",
  "art": "_1lnL9W_art",
  "body": "_1lnL9W_body",
  "card": "_1lnL9W_card",
  "cohort": "_1lnL9W_cohort",
  "controlRow": "_1lnL9W_controlRow",
  "controls": "_1lnL9W_controls",
  "cover": "_1lnL9W_cover",
  "empty": "_1lnL9W_empty",
  "filterSlot": "_1lnL9W_filterSlot",
  "headerRow": "_1lnL9W_headerRow",
  "heading": "_1lnL9W_heading",
  "imageWrap": "_1lnL9W_imageWrap",
  "inner": "_1lnL9W_inner",
  "navBtn": "_1lnL9W_navBtn",
  "pill": "_1lnL9W_pill",
  "pillLabel": "_1lnL9W_pillLabel",
  "prov": "_1lnL9W_prov",
  "question": "_1lnL9W_question",
  "ref": "_1lnL9W_ref",
  "section": "_1lnL9W_section",
  "sep": "_1lnL9W_sep",
  "slide": "_1lnL9W_slide",
  "subline": "_1lnL9W_subline",
  "swatch": "_1lnL9W_swatch",
  "track": "_1lnL9W_track",
  "viewport": "_1lnL9W_viewport",
});
